var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEspoch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.12 42.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#daf0f2;}.cls-2{fill:#263980;}.cls-3{fill:#c72318;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "35.84 1.69 13.25 1.69 1.95 21.25 13.25 40.82 35.84 40.82 47.14 21.25 35.84 1.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.85,42.51H12.27L0,21.25,12.27,0H36.85L49.12,21.25Zm-22.6-3.38h20.6L45.17,21.25,34.85,3.38H14.22L3.91,21.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25,31.15h0a4.84,4.84,0,0,0-2.21-.51H17.85v1.29h4.9a3,3,0,0,1,2.18.83h0a3,3,0,0,1,2.19-.83H32V30.64H27.15A4.85,4.85,0,0,0,25,31.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.31,25.26V8.59H15.54V25.28a2.85,2.85,0,0,0,.8,1.93,3.79,3.79,0,0,0,2.68,1h3.76A3,3,0,0,1,25,29h0a3,3,0,0,1,2.19-.83h3.53a3.79,3.79,0,0,0,2.85-1A2.81,2.81,0,0,0,34.31,25.26ZM16.85,9.88H33V25.3a1.51,1.51,0,0,1-.42,1,2.52,2.52,0,0,1-1.8.61v0H27.2a5,5,0,0,0-2.21.51h0a5,5,0,0,0-2.21-.51h-3.7a2.48,2.48,0,0,1-1.77-.6,1.52,1.52,0,0,1-.45-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.24,20.91h-.12a.63.63,0,0,1-.39-.15h0l-.08-.06a2.57,2.57,0,0,0-2.06-.58,1.27,1.27,0,0,1-.39,0,2.54,2.54,0,0,1-.5-.36,3.46,3.46,0,0,0-3.6-1,4.48,4.48,0,0,0-1.63.89l-2.36,1.86v1.65l3.17-2.51h0a2.43,2.43,0,0,1,3.44,0l0,0h0a3.2,3.2,0,0,0,1.07.66,2.32,2.32,0,0,0,.83,0,1.37,1.37,0,0,1,1.13.31,2,2,0,0,0,1.27.49h.18a1.65,1.65,0,0,1,1.29.46l1.14.87V21.91l-.35-.27A2.89,2.89,0,0,0,29.24,20.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31,17.36a6,6,0,0,0-.54-1.31l.75-.75-2.45-2.45L28,13.6a6.15,6.15,0,0,0-1.3-.54V12H23.21v1.06a6.15,6.15,0,0,0-1.3.54l-.76-.75L18.7,15.3l.75.75a6,6,0,0,0-.54,1.31H17.85v2.92l1-.8V18.36h.86L19.8,18a5.09,5.09,0,0,1,.71-1.72l.22-.34-.61-.61,1-1,.61.6.34-.21A5.42,5.42,0,0,1,23.79,14l.39-.08V13h1.46v.86L26,14a5.42,5.42,0,0,1,1.72.72l.34.21.6-.6,1,1-.6.61.22.34A5.09,5.09,0,0,1,30,18l.09.39H31V20h0l.26.19c.08.06.2.16.35.26l.36.28V17.34Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEspoch);
export default __webpack_public_path__ + "static/media/espoch.6f23f0496b8efe83ae867d91d92403e0.svg";
export { ForwardRef as ReactComponent };